
import configurations from "@/mixins/configurations.js";
import { mapGetters } from "vuex";

export default {
  mixins: [configurations],

  data() {
    return {
      offer: null,

      quantityCurrent: 1,
      isAddingToCart: false,
      isRemovingFromCart: false,
      isAddedToCart: false,
      isTogglingWishlist: false,
      inited: false,
    };
  },

  computed: {
    getAllSpecsSelected() {
      return this.product.specs.every(
        (spec) => typeof spec.active === "string"
      );
    },

    getHasActiveOffers() {
      return this.product.offers.some(
        (offer) => offer.ignoreCount || offer.count > 0
      );
    },

    getActiveOffersCount() {
      return this.product.offers.filter(
        (offer) => offer.ignoreCount || offer.count > 0
      ).length;
    },

    getHasSpecs() {
      return !!this.product.specs?.length;
    },

    getUnitPrice() {
      return this.getUnitPriceValue("price");
    },

    getUnitMSRP() {
      return this.getUnitPriceValue("msrpPrice");
    },

    getUnitTariff() {
      return this.getUnitPriceValue("tariff");
    },

    getQuantityValid() {
      return (
        this.quantityCurrent > 0 &&
        (this.getOfferMaxCount === -1
          ? true
          : this.quantityCurrent <= this.getOfferMaxCount)
      );
    },

    getOfferMaxCount() {
      return this.offer.ignoreCount ? -1 : Number(this.offer.count);
    },

    getOfferStockCount() {
      const count = Number(this.offer?.count);

      if (!isNaN(count) && count > 0) return Math.floor(count);

      if (this.offer?.ignoreCount) return this.offer?.ostkMsg || "many";

      return this.offer?.ostkMsg ?? 0;
    },

    isNew() {
      return this.product.status?.toLowerCase() === "new";
    },

    isSale() {
      return this.product.status?.toLowerCase() === "sale";
    },

    getCartPayload() {
      const payload = {
        id: this.offer.id,
        unit: this.offer.unit,
        quantity: this.quantityCurrent,
        configurations: this.getServerFormatedConfigurations,
        formatedConfigurations: this.getCleanConfigurations,
      };

      return payload;
    },

    ...mapGetters({
      CART: "CART/CART",
    }),
  },

  methods: {
    specHasOffer({ specName, specValue }) {
      const otherActiveSpecs = this.product.specs
        .filter((spec) => spec.active)
        .filter((spec) => spec.name !== specName)
        .map((spec) => {
          return {
            name: spec.name,
            active: spec.active,
          };
        });

      return this.product.offers.some((offer) => {
        let good = 0;

        offer.specs.forEach((s) => {
          if (
            s.name === specName &&
            s.value === specValue &&
            (offer.ignoreCount || offer.count > 0) &&
            (this.activeColor ? this.activeColor === offer.color : true)
          ) {
            good++;
          }

          otherActiveSpecs.forEach((ospec) => {
            if (
              s.name === ospec.name &&
              s.value === ospec.active &&
              (offer.ignoreCount || offer.count > 0) &&
              (this.activeColor ? this.activeColor === offer.color : true)
            ) {
              good++;
            }
          });
        });

        if (good === otherActiveSpecs.length + 1) {
          return true;
        }

        return false;
      });
    },

    checkIfSpecsAvailable() {
      if (this.product.specs) {
        this.product.specs.forEach((spec) => {
          spec.order.forEach((specItem) => {
            specItem.disabled = !this.specHasOffer({
              specName: spec.name,
              specValue: specItem.value,
            });
          });
        });
      }
    },

    getUnitPriceValue(field) {
      if (this.offer.units?.length > 1 && this.offer.unit) {
        const selectedUnit = this.offer.units.find(
          (u) => u.name === this.offer.unit
        );
        return selectedUnit?.[field] ?? null;
      }

      return null;
    },

    onSpecSelected() {
      this.checkIfSpecsAvailable();
      this.checkAllSpecs();

      // this check should be in this place
      if (this.getAllSpecsSelected) {
        this.$nextTick(() => {
          // this.scrollToConfigurations();
        });
      }
    },

    checkAllSpecs() {
      if (this.getAllSpecsSelected) {
        this.setCurrentOffer();
      } else {
        this.setDefaultOffer();
      }
    },

    setCurrentOffer() {
      const offer = this.product.offers
        .filter((offer) =>
          this.product.colors ? offer.color === this.activeColor : true
        )
        .find((offer) => {
          return offer.specs.every((spec) => {
            const name = spec.name;
            const currentSpec = this.product.specs.find((s) => s.name === name);

            return spec.value === currentSpec.active;
          });
        });

      if (offer) {
        this.setOffer(offer);
      } else {
        this.__logError("Offer not found");
      }
    },

    setOffer(offer) {
      this.$set(this, "offer", {
        ...offer,
        details: [],
        documents: [],
        unit: offer.defUnit,
      });
    },

    setDefaultOffer() {
      this.offer = {
        id: this.product.id,
        name: this.product.name,
        description: this.product.description,
        price: this.product.price,
        msrpPrice: this.product.msrpPrice,
        photo: this.product.photo,
        photos: this.product.photos,
        details: [],
        documents: [],
        units: [],
        unit: null,
      };
    },

    setOnceOffer() {
      const offer = this.product.offers.find(
        (offer) => offer.ignoreCount || offer.count > 0
      );

      offer.specs.forEach((productSpec) => {
        this.product.specs.find(
          (spec) => spec.name === productSpec.name
        ).active = productSpec.value;
      });
    },

    async addToCart() {
      this.isAddingToCart = true;

      try {
        await this.$store.dispatch("CART/ADD", this.getCartPayload);

        this.__toast("The product has been added to your cart");
        this.isAddedToCart = true;
      } catch (err) {
        console.log(err);
        this.__toastError(err?.source === "server" ? err.message : "");
      }

      this.isAddingToCart = false;
    },

    async removeFromCart() {
      this.isRemovingFromCart = true;

      const cartItem = this.CART.items.find((i) => i.id === this.product.id);

      if (cartItem) {
        try {
          await this.$store.dispatch("CART/REMOVE", {
            id: this.product.id,
            objectId: cartItem.objectId,
          });

          this.__toast("The product has been deleted from your cart");
          this.isAddedToCart = false;
        } catch (err) {
          console.log(err);
          this.__toastError(err?.source === "server" ? err.message : "");
        }
      }

      this.isRemovingFromCart = false;
    },

    async toggleWishlist() {
      this.isTogglingWishlist = true;

      const payload = {
        id: this.product.id,
      };

      if (this.product.favourite) {
        try {
          await this.$store.dispatch("WISHLIST/REMOVE", payload);
        } catch (err) {
          this.__logError(err);
        }
      } else {
        try {
          await this.$store.dispatch("WISHLIST/ADD", payload);
        } catch (err) {
          this.__logError(err);
        }
      }

      this.product.favourite = !this.offer.favourite;

      this.__toast(
        this.product.favourite ? "Saved to Wishlist" : "Removed from Wishlist"
      );

      this.isTogglingWishlist = false;
    },

    onQuantityChange(quantity) {
      this.quantityCurrent = quantity;
    },

    selectFirstSpecs() {
      this.product.specs.forEach((spec) => {
        if (spec.order.length === 1 && !spec.order[0].disabled) {
          spec.active = spec.order[0].value;
        }
      });
    },
  },

  created() {
    this.checkIfSpecsAvailable();

    if (this.type === "card") {
      this.setDefaultOffer();
    } else {
      if (this.getActiveOffersCount === 1) {
        this.setOnceOffer();
      } else {
        this.selectFirstSpecs();
        this.checkIfSpecsAvailable();
      }
    }

    this.checkAllSpecs();

    this.$nextTick(() => {
      this.inited = true;
    });
  },
};
